export interface ClassLessonAttendanceRecord {
  studentId: string;
  present: boolean;
  notes?: string | null;
}

export interface ClassLesson {
  id: string;
  classLessonId?: string;
  classId: string;
  lessonNumber: number;
  title: string;
  date: string;
  description: string;
  teacherName?: string;
  hasAttendance?: boolean;
  biblesCount?: number;
  offeringAmount?: number;
  notes?: string;
  presentCount?: number;
  absentCount?: number;
  studentAttendances?: ClassLessonAttendanceRecord[];
}

export const LESSONS_PER_TRIMESTER = 13;

export const buildLessonId = (classId: string, lessonNumber: number) => `${classId}-lesson-${lessonNumber}`;
